import React, { createContext, useContext, useState } from 'react';

const ActiveConversationContext = createContext();

export const useActiveConversation = () => {
    const context = useContext(ActiveConversationContext);
    if (!context) {
        throw new Error('useActiveConversation must be used within an ActiveConversationProvider');
    }
    return context;
};

export const ActiveConversationProvider = ({ children }) => {
    const [activeConversationId, setActiveConversationId] = useState(null);

    const setActiveConversation = (conversationId) => {
        setActiveConversationId(conversationId);
    };

    const clearActiveConversation = () => {
        setActiveConversationId(null);
    };

    const isConversationActive = (conversationId) => {
        return activeConversationId === conversationId;
    };

    return (
        <ActiveConversationContext.Provider value={{
            activeConversationId,
            setActiveConversation,
            clearActiveConversation,
            isConversationActive
        }}>
            {children}
        </ActiveConversationContext.Provider>
    );
}; 